<template>
  <div>
    <DiscoveryStatsOverall
      class="discovery-campaign-stats__overall"
      :campaign-id="campaignId"
      :package-name="campaignInfo.packageName"
      :range.sync="range"
    />
    <DiscoveryStatsActiveInstall
      :package-name="campaignInfo.packageName"
      :range="range"
    />
  </div>
</template>

<script>
import DiscoveryStatsOverall from './DiscoveryStatsOverall';
import DiscoveryStatsActiveInstall from './DiscoveryStatsActiveInstall';
import { DiscoveryAdsCampaigns } from '@/api/api';

import statsFilter from '@/mixins/statsFilter';
import campaignId from '@/mixins/advertisement/campaignId';
import { LAST_WEEK } from '@/constant';

export default {
  name: 'DiscoveryCampaignStats',

  components: {
    DiscoveryStatsOverall,
    DiscoveryStatsActiveInstall,
  },

  mixins: [statsFilter, campaignId],

  data() {
    return {
      loading: false,
      range: LAST_WEEK,
      stats: {},
      campaignInfo: {},
    };
  },

  mounted() {
    this.getCampaignInfo();
  },

  methods: {
    getCampaignInfo() {
      return DiscoveryAdsCampaigns.getCampaignInfo(this.campaignId).then(
        campaignInfo => {
          this.campaignInfo = campaignInfo;
        },
      );
    },
  },
};
</script>

<style lang="scss">
.discovery-campaign-stats {
  &__overall {
    margin-bottom: $global-margin * 2;
  }
}
</style>
